import environment from "@environment";

const UrlUtils = {
    _slash: "/",

    trimTrailingSlash(url: string) {
        return url?.endsWith(this._slash) ? url.slice(0, -1) : url
    },

    join(url: string, path: string | undefined) {
        url = this.trimTrailingSlash(url);

        if (!path) {
            return url;
        }

        const separator = path.startsWith(this._slash) ? "" : this._slash;

        return url + separator + path;
    },

    getLanguageCode() {
        const path = window.location.pathname;
        const match = path.match(/business\/(.*)\/mydstv/);
        return match != null && match.length > 0 ? match[1] : environment.DEFAULT_LANGUAGE;
    },

    getCountryCode() {
        const languageCode = UrlUtils.getLanguageCode();
        return languageCode.split("-")[1];
    },

    parseUrl(url: string) {
        if (url == null) {
            return "";
        }

        url = url.replace("{origin}", window.location.origin);

        const languageCode = this.getLanguageCode();
        url = url.replace("{language}", languageCode);

        return url;
    },

    getParameterByName(name: string, url = window.location.href) {
        name = name.replace(/[[\]]/g, "\\$&");

        const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)")
        const results = regex.exec(url);

        if (!results) {
            return null;
        }

        if (!results[2]) {
            return "";
        }

        return decodeURIComponent(results[2].replace(/\+/g, " "));
    },

    removeParameterFromQueryString(parameterToDelete: string) {
        const splitUri = window.location.href.split("?");

        if (splitUri.length < 2) {
            return;
        }

        const params = new URLSearchParams(splitUri[1]);
        params.delete(parameterToDelete);

        let newUrl = splitUri[0];

        const query = params.toString();

        if (query) {
            newUrl += `?${query}`;
        }

        window.history.pushState({}, "", newUrl);
    },

    getRootPath() {
        return this.parseUrl(environment.ROOT_PATH);
    },

    removeQueryParamsFromUrl() {
        const search = window.location.search.toString();

        if (search.length < 2) {
            return;
        }

        window.history.replaceState(null, "", window.location.href.replace(search, ""));
    }
}

export default UrlUtils;
